import * as React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import BackgroundImage from 'gatsby-background-image'
import Img from "gatsby-image"

const seo = {
    title: "Vibra One soundproof phone booth",
    description: "Vibra One is a one-person soundproof office booth with LED light, quiet ventilation, motion-sensed power and a sound-insulating sandwich wall. Exterior 2210 x 1040 x 940 mm. Delivered across the UK and the EU.",
}

const VibraOne = ({ data }) => {

    const grayBorder = { borderRight: '3px solid #7f7f7f' }
    const coverImageStack = [
        data.coverImage.childImageSharp.fixed,
        `linear-gradient(0deg, rgba(20, 0, 20, 0.2), rgba(20, 0, 20, 0.2))`
    ].reverse()

    return (
        <Layout seo={seo}>
            <div className="hero-area hero-slider-two vibra-one-page">
                <BackgroundImage
                    className="single-hero-slider-one"
                    Tag="section"
                    fluid={coverImageStack}
                    backgroundColor={`#040e18`}
                >
                    <div className="container">
                        <div className="row" style={{ marginTop: "-130px" }}>
                            <div className="col-lg-12">
                                <div className="hero-text-two text-left">
                                    <h1 className="hero-title--one d-none d-md-block d-lg-block d-xl-block" style={{ fontWeight: 800 }}>VIBRA One</h1>
                                    <h4 className="mt-30 hero-text d-none d-md-block d-lg-block d-xl-block" style={{ color: "#e0d5cc", fontSize: "30px" }}>
                                        The quiet room your open office is missing
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </BackgroundImage>
            </div>

            <div className="featuted-product-wrap section-space--pt_120 vibra-one-page d-block d-md-none d-lg-none d-xl-none">
                <div className="container">
                    <div className="row align-items-center ">
                        <div className="col">
                            <h1 style={{ fontWeight: 800 }}>VIBRA One</h1>
                            <p>The quiet room your open office is missing.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--pt_120 vibra-one-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h5 style={{ lineHeight: 1.6 }}>
                                Vibra One is a one-person soundproof booth for phone calls, video meetings and an hour of real focus. It stands on the floor, plugs into a standard socket and brings its own light and fresh air, so the office around it stays open and the person inside gets quiet.
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--pt_120 vibra-one-page">
                <div className="container">
                    <div className="row align-items-center featuted-product-one">
                        <div className="col-lg-6 col-md-6 order-lg-2 order-1">
                            <div className="product-thumbnail">
                                <Img fluid={data.ceilingImage.childImageSharp.fluid} alt="Vibra One ceiling with LED light and ventilation"></Img>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 order-lg-1 order-2">
                            <div className="featured-product-contect">
                                <div className="row">
                                    <div className="col" style={grayBorder}>
                                        <Img fluid={data.lightIcon.childImageSharp.fluid} alt=""></Img>
                                    </div>
                                    <div className="col-8">
                                        <h4>Light</h4>
                                        <p><br />Warm LED lighting (3000 K, IP20) that is bright enough for video calls and easy on the eyes for an hour of reading.</p>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '100px' }}>
                                    <div className="col" style={grayBorder}>
                                        <Img fluid={data.ventilationIcon.childImageSharp.fluid} alt=""></Img>
                                    </div>
                                    <div className="col-8">
                                        <h4>Ventilation</h4>
                                        <p><br />A quiet fan keeps the air fresh and the temperature steady, through a duct designed to let air in and keep office noise out.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--pt_120 vibra-one-page" style={{ background: '#fbfbfb', paddingBottom: '120px' }}>
                <div className="container">
                    <div className="row align-items-center featuted-product-one">
                        <div className="col-lg-6 col-md-6 order-lg-1 order-1">
                            <div className="product-thumbnail">
                                <Img fluid={data.tableImage.childImageSharp.fluid} alt="Vibra One interior table and power outlet"> </Img>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 order-lg-2 order-2">
                            <div className="featured-product-contect">
                                <div className="row">
                                    <div className="col" style={grayBorder}>
                                        <Img fluid={data.powerIcon.childImageSharp.fluid} alt=""></Img>
                                    </div>
                                    <div className="col-8">
                                        <h4>Power</h4>
                                        <p><br />A motion sensor switches light and ventilation on when you step in and off when you leave. Power outlet at the table, 100 to 240 V AC, from a standard socket.</p>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '100px' }}>
                                    <div className="col" style={grayBorder}>
                                        <Img fluid={data.insolationIcon.childImageSharp.fluid} alt=""></Img>
                                    </div>
                                    <div className="col-8">
                                        <h4>Sound insulation</h4>
                                        <p><br />A sandwich wall of laminated MDF, mineral wool and sound-absorbing felt on a wooden frame. Mass to block sound, absorption to soak it up, and a soft interior so your voice sounds natural rather than boxed in. <Link to="/guides/how-much-sound-insulation-does-a-phone-booth-need/">How booth insulation is measured</Link>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--pt_120 vibra-one-page">
                <div className="container">
                    <div className="row align-items-center featuted-product-one">
                        <div className="col-lg-6 col-md-6 order-lg-2 order-1">
                            <div className="product-thumbnail">
                                <Img fluid={data.dimensionsImage.childImageSharp.fluid} alt="Vibra One dimensions drawing"> </Img>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 order-lg-1 order-2">
                            <div className="featured-product-contect">
                                <h4 style={{ borderLeft: '3px solid #7f7f7f', padding: '10px' }}>Product <br /> dimensions</h4>
                                <br />
                                <h5>Exterior</h5>
                                <br />
                                <p>H 2210 mm x W 1040 mm x D 940 mm<br />
                                    H 87.00" x W 40.94" x D 37.00"</p>
                                <br />
                                <h5>Interior</h5>
                                <br />
                                <p>H 2050 mm x W 896 mm x D 880 mm <br />
                                    H 80.70" x W 35.27" x D 34.64"</p>
                                <br />
                                <p>Footprint just under one square metre. A ceiling of 2400 mm or more is comfortable. <Link to="/guides/phone-booth-or-meeting-pod/">What to check before you order</Link>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="featuted-product-wrap section-space--ptb_120 vibra-one-page" style={{ background: '#fbfbfb' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h3 className="section-title">See it before you decide</h3>
                            <p className="section-space--mt_20">Book a video walk-through with our team, ask about lead times for the UK and the EU, or request the technical data for your fit-out and fire risk assessment.</p>
                            <div className="button-box section-space--mt_40">
                                <Link to="/virtual-demo/" className="text-btn-normal">Book a virtual demo <i className="icon-arrow-right"></i></Link>
                                <span style={{ margin: '0 16px', color: '#999' }}>or</span>
                                <Link to="/contact-us/" className="text-btn-normal">Contact us <i className="icon-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
};

export const query = graphql`
  query {
    coverImage: file(
      relativePath: { eq: "vibra-one/cover.jpg" }
    ) {
      childImageSharp {
        fixed(width: 1920, height: 960) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    ceilingImage: file(relativePath: { eq: "vibra-one/vibra-ceiling.jpg" }){
        childImageSharp {
            fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    tableImage: file(relativePath: { eq: "vibra-one/vibra-table.jpg" }){
        childImageSharp {
            fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    dimensionsImage: file(relativePath: { eq: "vibra-one/vibra-dimensions.png" }){
        childImageSharp {
            fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    lightIcon: file(relativePath: { eq: "vibra-one/lightIcon.png" }){
        childImageSharp {
            fluid(maxWidth: 250) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    ventilationIcon: file(relativePath: { eq: "vibra-one/ventilationIcon.png" }){
        childImageSharp {
            fluid(maxWidth: 250) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    powerIcon: file(relativePath: { eq: "vibra-one/powerIcon.png" }){
        childImageSharp {
            fluid(maxWidth: 250) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
    insolationIcon: file(relativePath: { eq: "vibra-one/insolationIcon.png" }){
        childImageSharp {
            fluid(maxWidth: 250) {
                ...GatsbyImageSharpFluid_noBase64
            }
        }
    }
  }`

export default VibraOne
